import { NavigationWrapper } from '../../navigation-data';
import { ShiveRoutes } from '../../segments/route-segments';
import { PageKey } from '../../page-keys';
import { UrlSegmentDelimiter } from '../../../constants-repository/app-style.constants';

export const Projects: NavigationWrapper = {
  title: 'Projekte',
  route: ShiveRoutes.Projects,
};

export const ProjectOverview: NavigationWrapper = {
  title: 'Übersicht',
  route: ShiveRoutes.ProjectOverview,
};

export const ProjectAdd: NavigationWrapper = {
  title: 'Neues Projekt',
  route: ShiveRoutes.ProjectAdd,
  previousPage: PageKey.ProjectPageKeys.ProjectOverview,
};

export const ProjectProgress: NavigationWrapper = {
  title: 'Fortschritt',
  route: ShiveRoutes.ProjectProgress + UrlSegmentDelimiter + ShiveRoutes.AnyId,
  previousPage: PageKey.ProjectPageKeys.ProjectOverview,
};

export const ProjectEdit: NavigationWrapper = {
  title: 'Einstellungen',
  route: ShiveRoutes.ProjectEdit + UrlSegmentDelimiter + ShiveRoutes.AnyId,
  previousPage: PageKey.ProjectPageKeys.ProjectOverview,
};

export const ProjectExpenses: NavigationWrapper = {
  title: 'Ausgaben',
  route: ShiveRoutes.ProjectExpenses + UrlSegmentDelimiter + ShiveRoutes.AnyId,
  previousPage: PageKey.ProjectPageKeys.ProjectOverview,
};
export const ProjectAttachments: NavigationWrapper = {
  title: 'Anhänge',
  route: ShiveRoutes.ProjectAttachments + UrlSegmentDelimiter + ShiveRoutes.AnyId,
  previousPage: PageKey.ProjectPageKeys.ProjectOverview,
};
